// extracted by mini-css-extract-plugin
export var askAiIcon = "_kp-9";
export var container = "_kp-0";
export var groupSeparator = "_kp-a";
export var highlight = "_kp-4";
export var resultIcon = "_kp-5";
export var resultItem = "_kp-7";
export var resultSubtitle = "_kp-3";
export var resultTitle = "_kp-2";
export var resultsList = "_kp-1";
export var searchGroup = "_kp-6";
export var selected = "_kp-8";